import React, { useEffect } from "react";
import PropTypes from "prop-types";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import FormTextarea from "Common/Custom/FormTextarea";

const AddCandidateSelectionForm = ({
    fields,
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title,
    CandidateOptions,
    PositionOptions,
}) => {
    const optionConfig = {
        can_id: {
            list: CandidateOptions,
            valueKey: "id",
            labelKey: "name",
        },
        pos_id: {
            list: PositionOptions,
            valueKey: "position_id",
            labelKey: "position_name",
        },
    };

    useEffect(() => {
        if (values.can_id) {
            const candidate = CandidateOptions.find((c) => c.id === values.can_id);
            if (candidate) {
                handleChange({ target: { name: "pos_id", value: candidate.position_id } });
            }
        }
    }, [values.can_id]);

    const renderField = (field) => {
        if (field.type === "select") {
            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    options={getSelectOptions(field.name, optionConfig)}
                    error={errors[field.name]}
                />
            );
        }

        if (field.type === "textarea") {
            return (
                <FormTextarea
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            );
        }


        return (
            <FormInput
                key={field.name}
                field={field}
                value={values[field.name]}
                handleChange={handleChange}
                error={errors[field.name]}
            />
        );
    };

    return (
        <PageBody
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
        >
            {fields.map((field) => renderField(field))}

            <FormSubmitButton
                label="Save"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

AddCandidateSelectionForm.propTypes = {
    fields: PropTypes.array.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.string,
    CandidateOptions: PropTypes.array,
    PositionOptions: PropTypes.array,
};

AddCandidateSelectionForm.defaultProps = {
    errors: {},
    loading: false,
    title: "Add Candidate Selection",
    CandidateOptions: [],
    PositionOptions: [],
};

export default AddCandidateSelectionForm;
